module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-course-meal-b016133c98d8833701dec25246cea012.png";